import React from 'react'
import * as UI from 'ui'
import { Pipeline, TriggerPipelineOnClick } from '@morningtrain/react-pipelines'
import { CallbackOnPipe, useEnvValue } from '@morningtrain/react-helpers'
import { useForm } from '@morningtrain/react-resources'

export default function ResetNormOffsetAction ({ weekday, itemId }) {
  const [offset, setOffset] = useEnvValue('globals.inventory.norms.by_item.' + itemId + '.' + weekday + '.norm_offset')
  const form = useForm()

  const handleAction = () => {
    setOffset(null)
    form.setAsChanged()
  }

  return (
    <Pipeline>
      <TriggerPipelineOnClick>
        <UI.SquareButton className='w-5 h-5' color='red'>
          <UI.Icons.Trash />
        </UI.SquareButton>
      </TriggerPipelineOnClick>
      <CallbackOnPipe callback={handleAction} />
    </Pipeline>
  )
}
